<template>
    <div v-for="merch in list" 
        @click='detail_page(merch.id, false)'
        class="w-full flex surface-50 cursor-pointer
        flex-column xl:flex-row lg:flex-row md:flex-row sm:flex-row
        m-0 mb-2 xl:mb-3 lg:mb-3 md:mb-3
        p-3 xl:p-4 lg:p-4 md:p-4
        gap-2 xl:gap-4 lg:gap-3 md:gap-3
        border-round-2xl 
        text-left relative">

        <div class="flex flex-1 flex-row gap-2">
            <div class="flex flex-1 flex-column">
                <!--ID-->
                <span class="flex text-600 mb-2">
                    <span class="text-sm flex flex-row" >
                        <span class="flex ">{{ get_short_id(merch.id) }}</span> 
                    </span>
                </span>

                <!--NAME-->
                <div class="flex flex-row w-2">
                    <span class="flex text-700 text-xl font-medium white-space-nowrap">
                        {{ merch.name }}
                    </span>
                </div>
            </div>
            
            <!--DEPOSIT-->
            <div class="flex flex-1 flex-column w-2 mr-2 mb-2 xl:mb-0 lg:mb-0 md:md-0">
                <span class="flex text-600 mb-2">
                    <span class="text-sm flex flex-row">
                        <span class="flex ">
                            Депозит 
                        </span>
                    </span>
                </span>
                <div class="flex flex-row w-2">
                    <span v-if="merch.deposit" class="flex text-700 text-xl font-medium white-space-nowrap">
                        {{ get_format_amount(merch.deposit, 'usdt') }}
                    </span>
                </div>
            </div>
        </div>
        
        <!--RESERVES-->
        <div class="flex flex-1 flex-row">
            <div class="flex flex-column mr-3">
                <span class="text-sm text-600 mb-2 block">Резервы:</span>
                <span v-for="r in merch.reserves"
                    class="text-md text-900 block mb-2 text-sm">
                    {{ get_format_amount(r.amount, r.currency_code, 0) }} <span class="text-400 font-medium uppercase">({{ r.currency_code }})</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    name: 'ListMerchantDeposits',
    props: {
        list: {
            type: [Array, Object],
            required: true
        },
    },
    data() {
        return {
            loading: false,
            displayDialog: false,
            current_merchant: {},
            time_list: [
                {name: 0, code: 0},
                {name: 1, code: 1},
                {name: 2, code: 2},
                {name: 3, code: 3},
                {name: 4, code: 4},
                {name: 5, code: 5},
                {name: 6, code: 6},
                {name: 7, code: 7},
                {name: 8, code: 8},
                {name: 9, code: 9},
                {name: 10, code: 10},
                {name: 11, code: 11},
                {name: 12, code: 12},
                {name: 13, code: 13},
                {name: 14, code: 14},
                {name: 15, code: 15},
                {name: 16, code: 16},
                {name: 17, code: 17},
                {name: 18, code: 18},
                {name: 19, code: 19},
                {name: 20, code: 20},
                {name: 21, code: 21},
                {name: 22, code: 22},
                {name: 23, code: 23},
                {name: 24, code: 24},
            ],
        }
    },
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        get_format_amount(value, currency, decimals = 2) {
            return this.helper.format_amount(value, currency, decimals)
        },
        get_msk_time(data){
            let time = data + 3
            if(time>24){
                time = time - 24
            }
            return time+':00'
        },
        get_local_time(data){
            let time = data + 8
            if(time>24){
                time = time - 24
            }
            return time+':00'
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        toTg(username){
            if(!username) return false
            const url = 'https://t.me/' + username
            window.open(url, '_blank')
        },
        goToUser(id){
            this.$router.push({ path: '/admin/user/' + id })
        },
        get_bank_title(code){
            return this.helper.get_bank_title(code, this.$store.state.payment.banks, this.lang_)
        },
        get_bank_image(code){
            return this.helper.get_bank_image(code, this.$store.state.payment.banks)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        detail_page(id, new_tab = false) {
            if(new_tab){
                const routeData = this.$router.resolve({path: '/admin/merchant/' + id});
                window.open(routeData.href, '_blank');
            } else  this.$router.push({ path: '/admin/merchant/' + id })
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>